<div fxLayout="row" >

    <mat-form-field fxFlex = "40">
        <mat-label translate> generic.filter </mat-label>
        <input  matInput  [disabled]  = "disabled" type="search" placeholder="" [(ngModel)]="available_filter" name="available_filter">
        <button mat-button *ngIf="available_filter" matSuffix mat-icon-button aria-label="Clear" (click)="available_filter=''">
            <mat-icon>close</mat-icon>
    </button>
    </mat-form-field>

    <div fxFlex="20" >
        &nbsp;
    </div>

    <mat-form-field fxFlex = "40">
        <mat-label translate> generic.filter </mat-label>
        <input  matInput  [disabled]  = "disabled" type="search" placeholder="" [(ngModel)]="confirmed_filter" name="confirmed_filter">
        <button mat-button *ngIf="confirmed_filter" matSuffix mat-icon-button aria-label="Clear" (click)="confirmed_filter=''">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

</div>
 
 <div fxLayout="row" [style.width.%] = "100">

    <div fxFlex="40">
                <mat-selection-list #available_picking 
                    [(ngModel)]         =   "available_picked" 
                    [style.overflow]    =   "'auto'" 
                    [style.height]      =   "height"                    
                    >
                    <mat-list-option *ngFor="let item of available.filter(available_filter, display);" [value] = "item"
                        [disabled]  = "disabled"
                    >
                        {{ item[display] }}
                    </mat-list-option>
                    <mat-list-item *ngIf="available.filter(available_filter, display).length === 0">
                        {{ 'generic.no_elements' | translate }}
                    </mat-list-item>
                </mat-selection-list>
    </div>

    <div fxFlex="20" >

        <div>
            <button 
                mat-button 
                color               = "primary" 
                name                = "addBtn" 
                class               = "pointer"
                (click)             = "moveFromTo()" 
                [disabled]          = "available_picked.length === 0 || disabled"
                style               = "width : 100%"
            >
                {{ format.add }}
                <mat-icon>keyboard_arrow_right</mat-icon>

            </button>
        </div>

        <div style="margin-top: 10px;">
            <button 
                mat-button  
                color               = "primary" 
                name                = "addAllBtn" 
                class               = "pointer"
                (click)             = "moveAllFromTo()" 
                [disabled]          = "disabled"
                style               = "width : 100%"
            >
                {{ format.all }}
                 <mat-icon>skip_next</mat-icon>

            </button>
        </div>

        <div style="margin-top: 20px;">
            <button 
                mat-button  
                color               =   "primary" 
                name                =   "removeBtn" 
                class               =   "pointer"
                (click)             =   "moveToFrom()" 
                [disabled]          =   "confirmed_picked.length === 0 || disabled"
                style               = "width : 100%"
            >
                {{format.remove}}
                 <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
        </div>

         <div style="margin-top: 10px;">
            <button 
                mat-button 
                color               = "primary" 
                name                = "removeAllBtn" 
                class               = "pointer"
                (click)             = "moveAllToFrom()" 
                [disabled]          = "disabled"
                style               = "width : 100%"
            >
                {{ format.none }}
                <mat-icon>skip_previous</mat-icon>
            </button>
        </div>


    </div>


    <div fxFlex="40">

            <mat-selection-list #confirmed_picking 
                [(ngModel)] = "confirmed_picked"
                [style.overflow]="'auto'" 
                [style.height] ="height"
            >
                <mat-list-option *ngFor="let item of confirmed.filter(confirmed_filter, display);" [value] = "item"
                    [disabled]  = "disabled"
                >
                    {{ item[display] }}
                </mat-list-option>

                <mat-list-item *ngIf="confirmed.filter(confirmed_filter, display).length === 0">
                        {{ 'generic.no_elements' | translate }}
                </mat-list-item>

            </mat-selection-list>
       
    </div>

 </div>
